import { getTranslation } from "./translations"

export const formatTime = (h: number, m: number) =>
  `${(h + "").padStart(2, "0")}:${(m + "").padStart(2, "0")}`

export const getStoreOpenState = (day: IDay, curr?: Date): "closed" | "warn" | "open" | "future" => {
  if (!day || !day.openingTime)
    return "closed"

  const [marginH, marginM] = timeMinusMargin(day.closingTime.hour, day.closingTime.minute)
  let [from, to, toMargin] = [day.openingTime, day.closingTime, { hour: marginH, minute: marginM }]
    .map(x => {
      const d = now()
      d.setHours(x.hour)
      d.setMinutes(x.minute)
      return d
    })

  if (curr) {
    if (+curr >= +from) {
      if (+curr < +toMargin)
        return "open"
      if (+curr < +to)
        return "warn"
      return "closed"
    }
  }
  return "future"
}

export const now = () => {
  const d = new Date()
  const offset = ("serverTimeOffset" in window && typeof window["serverTimeOffset"] === "number" && Math.abs(window["serverTimeOffset"]) > 1000) ? window["serverTimeOffset"] : 0
  if (offset) d.setMilliseconds(d.getMilliseconds() + offset)
  return d
}

export const isStoreOpen = (openDays: IStore["days"]) => {
  const n = now()
  let index = n.getDay()
  if (index === 0)
    index = 6
  else
    index = index - 1
  const day = openDays[index]
  let open: "closed" | "warn" | "open" | "future"

  open = getStoreOpenState(day, n)

  return {
    open,
    day,
    index,
  }
}

export const timeMinusMargin = (h: number, m: number): [number, number] => {
  const margin = 30
  const d = now()
  d.setHours(h)
  d.setMinutes(m)
  d.setMinutes(d.getMinutes() - margin)
  return [d.getHours(), d.getMinutes()]
}

export const getNextOpen = (openDays: IStore["days"], index: number): [string, IDay] => {
  const isClosed = (d, checkTime?: boolean) => {
    if (!d.openingTime)
      return true
    return ["closed", "warn"].includes(getStoreOpenState(d, checkTime ? now() : undefined))
  }

  let i = index
  let count = 0
  while (isClosed(openDays[i], i === index)) {
    i = i > openDays.length - 2 ? 0 : i + 1
    count++
    if (count > 7)
      return
  }
  return [index === i ? getTranslation("today") : getTranslation("dayNames")[i], openDays[i]]
}

export interface ICoords { lat: number, lng: number }

export interface IStore {
  id: string
  name: string
  city: string
  address: string
  zip: string
  phone: string
  distance: number
  latitude: number
  longitude: number
  days: IDay[]
  isActive: boolean
  navigationUrl: string
  hasXlService: boolean
  remainingSeconds: number
}

export interface IDay {
  index: number
  name: string
  openingTime?: IOpeningTime
  closingTime?: IOpeningTime
}

export interface IOpeningTime {
  hour: number
  minute: number
}